"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KettingProvider = exports.getKettingContext = void 0;
const React = require("react");
const KettingContext = React.createContext({});
function getKettingContext() {
    return KettingContext;
}
exports.getKettingContext = getKettingContext;
const KettingProvider = ({ client, children }) => {
    const Context = getKettingContext();
    const contextValue = {
        client
    };
    return React.createElement(Context.Provider, { value: contextValue }, children);
};
exports.KettingProvider = KettingProvider;
//# sourceMappingURL=provider.js.map